export class FulfillmentMeta
{
    public fields: any = {};
    public data: any = [];
}
